import { ReactNode } from 'react';
import styled from 'styled-components';

export interface MobileLayoutProps {
  header?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
}

function MobileLayout(props: MobileLayoutProps) {
  const { header, footer, children } = props;
  return (
    <Layout>
      {header && <Header>{header}</Header>}
      <Content>{children}</Content>
      {footer && <Footer>{footer}</Footer>}
    </Layout>
  );
}

export default MobileLayout;

const Layout = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-width: 600px;
  margin: 0 auto;
  padding-bottom: var(--app-keyboard-inset-height, 0px);
  overflow: hidden;
  background: white;
`;

const Header = styled.header`
  flex: 0 0 auto;
`;

const Content = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
`;

const Footer = styled.footer`
  flex: 0 0 auto;
  background: white;
`;
